

































































































import { Component, Vue } from 'vue-property-decorator'
import { SearchItemType, TableColumnItemType, OperationItemType, OptionItemType } from '../../../types/type'
import { Pagination } from '../../../mixins/pagination'
import { CommonModule, UserModule } from '../../../store'
import { findItemForTree, disposeSearchParamsForCM, getNameTextInOptions } from '../../../utils/toolsForCommon'
import { encode } from 'js-base64'
@Component({
  name: 'CapitalApplicationForUseOfPending',
  mixins: [Pagination],
  components: {
    'search-module': () => import('../../../components/common/searchModule.vue'),
    'concise-card-have-title-acquiescent': () => import('../../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'table-module': () => import('../../../components/common/tableModule.vue'),
    'my-dialog': () => import('../../../components/common/myDialog.vue'),
    'application-container-table': () => import('../../../components/applicationContainerTable/index.vue'),
    'loading-container': () => import('../../../components/loading.vue')
  }
})
export default class CapitalApplicationForUseOfPending extends Vue {
  public loading = false
  // 搜索条件的最终选中项：
  public searchCheckList: Array<string> = []
  // 所有搜索条件：
  public searchList: Array<SearchItemType> = [
    {
      title: '申请日期',
      key: 'dateInterval',
      type: 'dateForDaterange',
      value: '',
      placeholder: '请选择日期',
      show: true,
      disabled: false
    },
    {
      title: '食堂专户账号',
      key: 'account',
      type: 'input',
      value: '',
      placeholder: '请输入食堂专户账号',
      show: true,
      disabled: false
    },
    {
      title: '开户行',
      key: 'depositBank',
      type: 'input',
      value: '',
      placeholder: '请输入开户行',
      show: true,
      disabled: false
    },
    {
      title: '审批日期',
      key: 'dateIntervalForshenpiriqi',
      type: 'dateForDaterange',
      value: '',
      placeholder: '请选择审批日期',
      show: true,
      disabled: false
    },
    // {
    //   title: '操作人',
    //   key: 'updatedBy',
    //   type: 'input',
    //   value: '',
    //   placeholder: '请输入操作人',
    //   show: true,
    //   disabled: false
    // },
    {
      title: '审批人',
      key: 'auditor',
      type: 'input',
      value: '',
      placeholder: '请输入审批人',
      show: true,
      disabled: false
    },
    {
      title: '处理进度',
      key: 'status',
      type: 'select',
      value: '',
      placeholder: '请选择处理进度',
      selectOptions: [],
      show: true,
      disabled: false
    }
  ]
  // 列表列有哪些：
  public tableColumnList: Array<TableColumnItemType> = [
    {
      title: '编号',
      key: 'uniqueCode',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '280px'
    },
    {
      title: '处理进度',
      key: 'status',
      type: 'tag',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '乡镇',
      key: 'townName',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '学校',
      key: 'schoolName',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '食堂专户名称',
      key: 'accountName',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '食堂专户账号',
      key: 'account',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '开户行',
      key: 'depositBank',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '开户行号',
      key: 'depositBankCode',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '申请资金金额（元）',
      key: 'applyAmount',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '申请事由',
      key: 'applyReason',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '250px'
    },
    {
      title: '申请时间',
      key: 'time',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '资金拨付时间',
      key: 'appropriateTime',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    // {
    //   title: '操作人',
    //   key: 'updatedBy',
    //   type: 'text',
    //   showStateForTableHeader: 'unilaminar',
    //   width: '200px'
    // }
    {
      title: '审批人',
      key: 'auditors',
      type: 'listForTitleValueShow',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    }
  ]
  // 列表每一行的操作有哪些：
  public columnOperationList: Array<OperationItemType> = [
    {
      title: '详情',
      key: 'detail',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '取消',
      key: 'cancelForCapitalApplicationForUseOfPendingOfSchool',
      type: 'danger',
      size: 'mini'
    },
    {
      title: '资金拨付证明',
      key: 'capitalAppropriationFile',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '确认',
      key: 'confirmForCapitalAppropriationHistoryOfSchool',
      type: 'success',
      size: 'mini'
    },
    {
      title: '审批记录(有驳回)',
      key: 'failForbackOfCapitalApplication',
      type: 'danger',
      size: 'mini'
    },
    {
      title: '修改申请',
      key: 'updateForCapitalApplicationForUseOfPendingOfSchool',
      type: 'warning',
      size: 'mini'
    }
  ]
  // 列头操作：
  public operationForButtonOfTableHeader: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-bottom'></span>导出待处理资金申请列表",
      key: 'exportExcel',
      type: 'primary',
      size: '',
      canExportOutFlag: true,
      titleCopy: "<span class='el-icon-bottom'></span>导出待处理资金申请列表",
      exportResultFileName: '待处理资金申请列表.xlsx',
      exportLoading: "<span class='el-icon-loading'></span>正在导出中，请稍后",
      exportError: '抱歉，导出失败',
      exportSuccess: '导出成功'
    }
  ]
  public dialogFlagForUpdateApplyOrApplyDetail: boolean = false
  // 申请表的详细信息：
  public detailInfo: any = {}
  public loadingForUpdateBaseApply: boolean = false
  public appearType = ''
  // 枚举选项：
  // 处理进度：
  public optionsForAuditStatus: Array<OptionItemType> = [
    {
      name: '中心学校待审批',
      value: 1
    },
    {
      name: '后勤待审批',
      value: 2
    },
    {
      name: '中心学校驳回',
      value: 3
    },
    {
      name: '城投待审批',
      value: 4
    },
    {
      name: '后勤驳回',
      value: 5
    },
    {
      name: '城投待打款',
      value: 6
    },
    {
      name: '城投审核驳回',
      value: 7
    },
    {
      name: '城投转账驳回',
      value: 8
    },
    {
      name: '学校待确认',
      value: 9
    },
    {
      name: '已完成',
      value: 10
    }
  ]
  public optionsForAuditStatusForTagType: Array<OptionItemType> = [
    {
      name: '',
      value: 1
    },
    {
      name: '',
      value: 2
    },
    {
      name: 'danger',
      value: 3
    },
    {
      name: '',
      value: 4
    },
    {
      name: 'danger',
      value: 5
    },
    {
      name: '',
      value: 6
    },
    {
      name: 'danger',
      value: 7
    },
    {
      name: 'danger',
      value: 8
    },
    {
      name: 'success',
      value: 9
    },
    {
      name: 'success',
      value: 10
    }
  ]
  // 查看上传拨付证明相关：
  public dialogFlagForUploadFile :boolean = false
  public loadingForUploadFile: boolean = false
  public transferFile: string = ''
  // 附件预览：
  public dialogVisibleForPreviewFile: boolean = false
  public dialogVisiblePreviewUrl: string = ''
  public dialogVisibleiframeShowFlag: boolean = false
  // 查看驳回详情：
  public visibleForFailBackDetailList: boolean = false
  public failBackDetailList: Array<any> = []
  public loadingForFailBackDetailList: boolean = false

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get userInfo () {
    return UserModule.userInfo
  }

  get orgName (): string {
    const org = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
    return org && org['name'] ? org['name'] : '- -'
  }

  async mounted () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization()
    ])
    this.disposeSearchCheckedInit()
    this.disposeForSearchList()
    this.getTableDataList()
  }

  // 选择项初始化：
  disposeSearchCheckedInit () {
    // this.searchCheckList = this.searchList.length > 2 ? this.searchList.slice(0, 2).map(item => item.key) : this.searchList.slice(0).map(item => item.key)
    this.searchCheckList = this.searchList.slice(0).map(item => item.key)
  }

  // 选择项数据处理：
  disposeForSearchList () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
        case 'status':
          item.selectOptions = this.optionsForAuditStatus.filter(item => item.value !== 10)
          break
      }
      return item
    })
  }

  // 操作按钮：
  operationForButton ({ key }, row) {
    switch (key) {
      case 'detail':
        this.dialogFlagForUpdateApplyOrApplyDetail = true
        this.detailInfo = row
        this.appearType = 'detail'
        break
      case 'cancelForCapitalApplicationForUseOfPendingOfSchool':
        this.operationForDisposeTheApply([row.id], 0, '确定要取消此资金申请记录吗？')
        break
      case 'capitalAppropriationFile':
        this.dialogFlagForUploadFile = true
        row.file && (this.transferFile = row.file)
        console.log(row, 'row')
        break
      case 'confirmForCapitalAppropriationHistoryOfSchool':
        this.operationForDisposeTheApply([row.id], 2, '要确认此资金申请记录吗？')
        break
      case 'failForbackOfCapitalApplication':
        this.visibleForFailBackDetailList = true
        this.getFailBackDetail(row.id)
        break
      case 'exportExcel':
        // 开始导出：
        this.operationForButtonOfTableHeader.forEach(async item => {
          if (item.key === 'exportExcel') {
            if (!item.canExportOutFlag) return this.$message.error('请等待上一次请求完成！')
            item.canExportOutFlag = false
            item.title = item.exportLoading
            const searchParams = disposeSearchParamsForCM(this.searchList, this.searchCheckList)
            const params = {
              ...searchParams,
              schoolIds: [this.userInfo.organizationId],
              role: 'SCHOOL',
              completed: 0
            }
            const result = await (this as any).$http.capitalAppExport(params)
            if (result.status !== 200) {
              this.$message.error(item.exportError)
              item.canExportOutFlag = true
              item.title = item.titleCopy
              return false
            };
            const blob = new Blob([result.data], {
              type: 'application/vnd.ms-excel'
            })
            const objectUrl = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = objectUrl
            a.download = this.orgName + '--' + item.exportResultFileName
            a.click()
            // 释放临时的对象url
            window.URL.revokeObjectURL(objectUrl)
            this.$message.success(item.exportSuccess)
            item.canExportOutFlag = true
            item.title = item.titleCopy
          }
        })
        break
      case 'updateForCapitalApplicationForUseOfPendingOfSchool':
        this.dialogFlagForUpdateApplyOrApplyDetail = true
        this.detailInfo = row
        this.appearType = 'update'
        this.$nextTick(() => {
          this.$refs.refForApplicationContainerTable['applyAmount'] = row.applyAmount || ''
          this.$refs.refForApplicationContainerTable['applyReason'] = row.applyReason || ''
        })
        break
    }
  }

  async getFailBackDetail (id) {
    try {
      this.failBackDetailList = []
      this.loadingForFailBackDetailList = true
      const params = {
        auditScene: 3, // 1:会计凭证审核;2:资金转账记录;3:资金使用申请
        id
      }
      const { data: result } = await (this as any).$http.getLogAudit(params)
      this.loadingForFailBackDetailList = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.failBackDetailList = (result.data || []).map(item => {
        let res = ''
        const NodeRes = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', item['operatorOrg'])
        if (!Object.keys(NodeRes).length) {
          res = '- -'
        } else {
          res = NodeRes['name']
        }
        item.description = `
          ${item.audit ? '通过' : '驳回'}
          ----
          ${res}
          组织节点的用户（
          ${item['operatorName']}
          ）在
          ${item['time']}
          进行处理，处理完的状态为：
          ${getNameTextInOptions(this.optionsForAuditStatus, item['resultStatus'])}
          ，处理原因为：
          ${item['reason'] ? item['reason'] : '- -'}
        `
        return item
      })
    } catch (err) {
      console.log(err)
    }
  }

  // 处理申请 ：
  operationForDisposeTheApply (ids: Array<string | number>, operation: number, confirmText: string) {
    let messageText = ''
    switch (operation) {
      case 0:
        messageText = '操作成功，已取消'
        break
      case 2:
        messageText = '操作成功，已确认'
        break
    }
    this.$confirm(confirmText, '提示', {
      confirmButtonText: `确定`,
      cancelButtonText: `取消`,
      type: 'warning'
    }).then(async () => {
      let { data: result } = await (this as any).$http.capitalAppApprove({
        ids,
        operation,
        role: 'SCHOOL'
      })
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(messageText)
      this.getTableDataList()
    }).catch(() => {})
  }

  async getTableDataList () {
    try {
      const _that: any = this
      this.loading = true
      const pageParams = {
        pageNo: _that.currentPage,
        pageSize: _that.pageSize
      }
      const searchParams = disposeSearchParamsForCM(this.searchList, this.searchCheckList)
      const params = {
        ...pageParams,
        ...searchParams,
        schoolIds: [this.userInfo.organizationId],
        role: 'SCHOOL',
        completed: 0 // 1表示查询完成的申请，0表示查询未完成的申请
      }
      const { data: result } = await (this as any).$http.capitalAppQuery(params)
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      _that.tableDataList = ((result.data && result.data.records) || []).map(item => {
        item['tagType'] = getNameTextInOptions(this.optionsForAuditStatusForTagType, item.status)
        item.status = getNameTextInOptions(this.optionsForAuditStatus, item.status)
        item.auditors = item.auditors || []
        return item
      })
      _that.total = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  resetBtn () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
        default:
          item.value = ''
          break
      }
      return item
    })
  }

  searchBtn (searchCheckListSelf) {
    let _that: any = this
    _that.currentPage = 1
    _that.pageSize = 10
    this.searchCheckList = searchCheckListSelf
    this.getTableDataList()
  }

  async saveForUpdateApply () {
    try {
      const applyAmount = this.$refs.refForApplicationContainerTable['applyAmount']
      const applyReason = this.$refs.refForApplicationContainerTable['applyReason']
      if (!applyAmount) return this.$message.warning('请输入本次申请金额')
      if (!applyReason) return this.$message.warning('请输入资金申请事由')
      const params = {
        ...this.detailInfo,
        applyAmount,
        applyReason,
        status: 3
      }
      this.loadingForUpdateBaseApply = true
      const { data: result } = await (this as any).$http.capitalAppUpdate(params)
      this.loadingForUpdateBaseApply = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success('资金使用申请审批表修改成功')
      setTimeout(() => {
        this.dialogFlagForUpdateApplyOrApplyDetail = false
        this.getTableDataList()
      }, 500)
    } catch (err) {
      console.log(err)
    }
  }

  // 预览：
  previewBtn (v) {
    let _that: any = this
    if (!v) return this.$message.error('抱歉，没有可预览的文件哦！')
    this.dialogVisibleForPreviewFile = true
    let previewUrl = _that.$previewURL + '/onlinePreview?url=' + encodeURIComponent(encode(v))
    this.dialogVisiblePreviewUrl = previewUrl
  }

  // 预览框打开的时候：
  dialogVisibleOpened () {
    let _that: any = this
    _that.dialogVisibleiframeShowFlag = false
    _that.$nextTick(() => {
      let iframeBox = document.querySelector('#iframeBoxOfdialogVisible')
      if ((iframeBox as any).attachEvent) {
        ;(iframeBox as any).attachEvent('onload', function () {
          _that.dialogVisibleiframeShowFlag = true
        })
      } else {
        ;(iframeBox as any).onload = function () {
          _that.dialogVisibleiframeShowFlag = true
        }
      }
      _that.dialogVisibleiframeShowFlag = true
    })
  }
}
